export default function loggedRedirection({ next, store, router }) {
	// if user is not logged, keep forward
	if (!store.state.user.uid) return next();
	// otherwise, redirect to Home
	router.push({ name: 'Home' });
}
